<template>
  <b-col sm="12" class="mt-2 mb-2">
    <div class="card">
      <div class="card-header main-card">Reservas sin grupo</div>
      <div class="card-body">
        <div class="d-flex justify-content-between">
          <div>
            <p>Reservas que no tienen un grupo de actividad (mañana, tarde, etc.) asignado automáticamente y que necesitan atención manual</p>
            <div>
              Completo: {{bookingsOrphanGroup.filter((item) => item.excursion_service && item.pickup_service).length}} / 
              Solo excursion: {{bookingsOrphanGroup.filter((item) => item.excursion_service && !item.pickup_service).length}} / 
              Solo pickup: {{bookingsOrphanGroup.filter((item) => !item.excursion_service && item.pickup_service).length}} / 
              Sin bus (Solo ticket): {{bookingsOrphanGroup.filter((item) => !item.excursion_service && !item.pickup_service).length}}
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-form-group label="Filtrar reservas" class="d-flex">
                <b-form-radio-group v-model="viewOrphanFilter" id="radio-group-orphan">
                  <b-form-radio name="ver-todo-orphan" :value="'all'">Todas</b-form-radio>
                  <b-form-radio name="ver-service-complete" :value="'complete-service'">Completo</b-form-radio>
                  <b-form-radio name="ver-service-only-pickup" :value="'only-pickup-service'">Solo con bus pickup</b-form-radio>
                  <b-form-radio name="ver-service-only-excursion" :value="'only-excursion-service'">Solo con bus excursión</b-form-radio>
                  <b-form-radio name="ver-service-nothing" :value="'no-service'">Sin servicio de bus (Solo ticket)</b-form-radio>
                </b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <Spinner v-if="this.$store.getters.isOrphanBookingsLoading" color="#fedd00" />
        <div v-else>
          <table
            v-if="this.$store.state.bookings.bookingsOrphanGroup.length > 0"
            class="table table-striped"
          >
            <thead>
              <tr>
                <th scope="col">Cliente</th>
                <th scope="col">Num. Reserva</th>
                <th scope="col">Actividad</th>
                <th scope="col">Inicio</th>
                <th scope="col">Idioma</th>
                <th scope="col">Pax</th>
                <th scope="col">1/2</th>
                <th scope="col">Total Pax</th>
                <th scope="col">Punto venta</th>
                <th scope="col">Hotel</th>
                <!-- <th scope="col">Hab</th> -->
                <th scope="col">Grupo</th>
                <th scope="col">Propuesta parada</th>
                <th scope="col">Checks</th>
                <th scope="col" style="width: 15%;"></th>
              </tr>
            </thead>
            <tbody v-if="viewOrphanFilter == 'all' || viewOrphanFilter == 'complete-service'">
              <tr>
                <td colspan="14" class="font-weight-bold" style="background-color: white; border-top: 2px solid;">
                  Reservas que <span class="text-danger">incluyen</span> servicio de bus completo
                </td>
              </tr>
              <tr v-if="bookingsOrphanGroup.filter((item) => item.excursion_service && item.pickup_service).length == 0">
                <td colspan="14" style="background-color: white;">
                  No hay en esta programación
                </td>
              </tr>
              <bookings-orphan-table-row 
                v-for="(bookingOrphanOfGroup, index) in bookingsOrphanGroup.filter((item) => item.excursion_service && item.pickup_service)"
                :key="index" :bookingOrphanOfGroup="bookingOrphanOfGroup" />

            </tbody>

            <!-- solo servicio de bus de excursion -->
            <tbody v-if="viewOrphanFilter == 'all' || viewOrphanFilter == 'only-excursion-service'">
              <tr>
                <td colspan="14" class="font-weight-bold" style="background-color: white; border-top: 2px solid;">
                  Reservas que <span class="text-danger">SOLO incluyen</span> servicio de bus de excursión
                </td>
              </tr>
              <tr v-if="bookingsOrphanGroup.filter((item) => item.excursion_service && !item.pickup_service).length == 0">
                <td colspan="14" style="background-color: white;">
                  No hay en esta programación
                </td>
              </tr>
              <bookings-orphan-table-row
                v-for="(bookingOrphanOfGroup) in bookingsOrphanGroup.filter((item) => item.excursion_service && !item.pickup_service)"
                :key="bookingOrphanOfGroup.id" :bookingOrphanOfGroup="bookingOrphanOfGroup"
              />
            </tbody>

            <!-- solo servicio de bus de recogida -->
            <tbody v-if="viewOrphanFilter == 'all' || viewOrphanFilter == 'only-pickup-service'">
              <tr>
                <td colspan="14" class="font-weight-bold" style="background-color: white; border-top: 2px solid;">
                  Reservas que <span class="text-danger">SOLO incluyen</span> servicio de bus de recogida
                </td>
              </tr>
              <tr v-if="bookingsOrphanGroup.filter((item) => !item.excursion_service && item.pickup_service).length == 0">
                <td colspan="14" style="background-color: white;">
                  No hay en esta programación
                </td>
              </tr>
              <bookings-orphan-table-row
                v-for="(bookingOrphanOfGroup) in bookingsOrphanGroup.filter((item) => !item.excursion_service && item.pickup_service)"
                :key="bookingOrphanOfGroup.id" :bookingOrphanOfGroup="bookingOrphanOfGroup"
              />
            </tbody>

            <!-- sin servicio de bus [solo ticket] -->
            <tbody v-if="viewOrphanFilter == 'all' || viewOrphanFilter == 'no-service'">
              <tr>
                <td colspan="14" class="font-weight-bold" style="background-color: white; border-top: 2px solid;">
                  Reservas que <span class="text-danger">NO incluyen</span> ningún servicio de bus [SOLO TICKET]
                </td>
              </tr>
              <tr v-if="bookingsOrphanGroup.filter((item) => !item.excursion_service && !item.pickup_service).length == 0">
                <td colspan="14" style="background-color: white;">
                  No hay en esta programación
                </td>
              </tr>
              <bookings-orphan-table-row
                v-for="(bookingOrphanOfGroup) in bookingsOrphanGroup.filter((item) => !item.excursion_service && !item.pickup_service)"
                :key="bookingOrphanOfGroup.id" :bookingOrphanOfGroup="bookingOrphanOfGroup"
              />
            </tbody>

          </table>
          <h4 v-else class="text-center m-3">
            <i class="fa fa-fw fa-check-circle text-success"></i>
            <span>Todas las reservas de la búsqueda están asignadas</span>
          </h4>
        </div>
      </div>
    </div>
    
  </b-col>
</template>

<script>
/* eslint-disable */
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import ShowCompleteBookingModal from "../Modal/ShowCompleteBookingModal";
import { mapGetters } from "vuex";
import BookingChecksCell from '../BookingCard/BookingChecksCell.vue';
import BookingsOrphanTableRow from './BookingsOrphanTableRow.vue';

export default {
  components: {
    Spinner,
    ShowCompleteBookingModal,
    BookingChecksCell,
    BookingsOrphanTableRow
  },
  data() {
    return {
      selectedStop: [],
      viewOrphanFilter: 'all', // 'only-bus-service',
    };
  },
  computed: {
    ...mapGetters(['bookingsOrphanGroup']),
    ...mapGetters(["stops"]),
    ...mapGetters(['groups', 'groupsListAdmin']),
    ...mapGetters(['activeTab']),
    ...mapGetters(['activeOption']),
  },
  async mounted() {
    const stopFilter = {
      activity_group: this.$store.getters.filterGroup,
    };
    await this.$store.dispatch("stops/loadStops", stopFilter);
    
  },
  methods: {
    
  },
};
</script>


<style scoped>
#checks_column i, #stop_column i {
  font-size: 14px;
  margin-left: 2px;
}
</style>